// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Whx","col":"styles_col__kXjHJ"};